import React from "react";
import PropTypes from "prop-types";
import { getLogoURL } from "../../../constants/url-constants";
import { WHITE_LOGO_URL } from "../../../constants/app-constants";

const Logo = ({ width = "80", height = "39", isWhiteLogo = false }) => {
    return (
        <img width={width} height={height} style={{width, height}} src={isWhiteLogo ? WHITE_LOGO_URL : getLogoURL()} alt="CARS24" />
    );
};

Logo.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    isWhiteLogo: PropTypes.bool
};

export default Logo;
